import { ReactMount as Components } from './Libraries/bootstrap';

/* Libraries First as they will expose functionality */
require('./Libraries/EventTracking')
require('./Libraries/ScrollTo/offset')
require('./Libraries/Dropdowns/submit-on-change')
require('./Libraries/ResponsiveIframe')
require('./Libraries/Accordion')
require('./Libraries/AlternatingImageText/listener')
require('./Libraries/BlockContent/listener')
// require('./Libraries/Clipboard')
require('./Libraries/Lightbox/listener')
require('./Libraries/Maps/listener')
require('./Libraries/MegaMenu/listener')
require('./Libraries/Modal/listener')
require('./Libraries/PhoneEmailPopUp')
require('./Libraries/ReadMore/listener')
require('./Libraries/StickyNav')
require('./Libraries/Swiper/listener')
require('./Libraries/Timeline/listener')
require('./Libraries/VideoModal/listener')
require('./Libraries/VideoStream/listener')
require('./Libraries/Aos/listener')

Components({
    // QuickSearch: () => import(/* webpackChunkName: "quick-search" */'./components/quick-search'),
    ProductSpecs: () => import(/* webpackChunkName: "product-specs" */'./components/product-specs'),
    HeaderCarousel: () => import(/* webpackChunkName: "header-carousel" */'./components/header-carousel'),
    // ProductImageSwap: () => import(/* webpackChunkName: "product-image-swap" */'./components/product-image-swap'),
    // ProductCarousel: () => import(/* webpackChunkName: "product-carousel" */'./components/product-carousel'),
    TestimonialCarousel: () => import(/* webpackChunkName: "testimonial-carousel" */'./components/testimonial-carousel'),
    // MapSearch: () => import(/* webpackChunkName: "map-search" */'./components/map-search'),
    // Map: () => import(/* webpackChunkName: "google-map" */'./components/map'),
    // FilterSidebar: () => import(/* webpackChunkName: "map" */'./components/filters-sidebar'),
    ShareButton: () => import(/* webpackChunkName: "map" */'./Libraries/SocialShare'),
    // MegaMenu: () => import(/* webpackChunkName: "mega-menu" */'./Libraries/MegaMenu'),
    // CareersForm: () => import(/* webpackChunkName: "careers-form" */'./forms/careers-form'),
    // ProductForm: () => import(/* webpackChunkName: "product-form" */'./forms/product-form'),
    // DealerForm: () => import(/* webpackChunkName: "dealer-form" */'./forms/dealer-form'),
    // OurOfficesForm: () => import(/* webpackChunkName: "our-offices-form" */'./forms/our-offices-form'),
    // ServicingForm: () => import(/* webpackChunkName: "servicing-form" */'./forms/servicing-form'),
    // CompetenceCentreForm: () => import(/* webpackChunkName: "competence-centre-form" */'./forms/competence-centre-form'),
    // SparesForm: () => import(/* webpackChunkName: "spares-form" */'./forms/spares-form'),
    // ContactForm: () => import(/* webpackChunkName: "contact-form" */'./forms/contact-form'),
    // SupportForm: () => import(/* webpackChunkName: "contact-form" */'./forms/support-form'),
    // GenericForm: () => import(/* webpackChunkName: "generic-form" */'./forms/generic-form'),
    // SeminarsForm: () => import(/* webpackChunkName: "seminars-form" */'./forms/seminars-form'),
    // PurchaseGatewayForm: () => import(/* webpackChunkName: "purchase-gateway-form" */'./forms/purchase-gateway-form'),
    ToolTip: () => import(/* webpackChunkName: "tool-tip" */'./components/tooltip'),
    HeaterRecommendations: () => import(/* webpackChunkName: "heater-recommendations" */'./tools/heater-recommendations'),
    AirExchangeRate: () => import(/* webpackChunkName: "air-exchange-rate" */'./tools/air-exchange-rate'),
    RoomSizeCalc: () => import(/* webpackChunkName: "room-size-calc" */'./tools/room-size-calc'),
    MasterWarranty: () => import(/* webpackChunkName: "master-warranty" */'./tools/master-warranty'),
    PoolHeaterTool: () => import(/* webpackChunkName: "pool-heater-tool" */'./tools/PoolHeaters/PoolHeaterTool'),
    HeatPumpForm: () => import(/* webpackChunkName: "pool-heater-form" */'./tools/PoolHeaters/Forms/EnquiryForm'),
    PurchaseOptions: () => import(/* webpackChunkName: "purchase-options" */'./components/purchase-options'),
    Products: () => import(/* webpackChunkName: "products" */'./components/algolia/products'),
    Articles: () => import(/* webpackChunkName: "articles" */'./components/algolia/articles'),
    Downloads: () => import(/* webpackChunkName: "downloads" */'./components/algolia/downloads'),
    Tools: () => import(/* webpackChunkName: "tools" */'./components/algolia/tools'),
    SearchBox: () => import(/* webpackChunkName: "search" */'./components/algolia/searchbox'),
    SearchResults: () => import(/* webpackChunkName: "search" */'./components/algolia/search-results'),
})

/* Site specific components */
require('./components/form-labels')
require('./components/twig-button-spinner')
require('./components/lazy-bg-image')
require('./components/filters-sidebar')

if (document.getElementById('particles-js')) {
    require('./components/particles')
}

if (document.getElementById('landing-splash')) {
    require('./components/landing')
}

// Formie CSRF
// Wait until Formie has been loaded and initialized
// document.addEventListener('onFormieInit', (event) => {
//     // Fetch the Form Factory once it's been loaded
//     let Formie = event.detail.formie;
//
//     // Refresh the necessary bits that are statically cached (CSRF inputs, captchas, etc)
//     document.querySelectorAll('form[data-fui-form]').forEach(function(form) {
//         Formie.refreshForCache(form.id);
//     })
//
// });

